import Vue from 'vue';

const request = Vue.observable({
	device: {},
	repairs: [],
	hiddenRepair: '',
	iris: [],
	acts: [],
	responsible: {},
	service: {},
	actForms: [],
});

export default request;
